import { Accordion, Icon, Text } from "@certn/cascadia-react";
import { AccordionPanel } from "@certn/cascadia-react/components/accordion/AccordionPanel";
import { AccordionToggle } from "@certn/cascadia-react/components/accordion/AccordionToggle";
import { css } from "@emotion/css";

interface SectionProps {
  data: React.ReactNode;
  title: string;
  testID?: string;
}

export function CollapsibleSection(props: SectionProps) {
  const { data, title, testID } = props;
  return (
    <Accordion>
      {({ isOpen }) => (
        <div
          data-open={isOpen}
          className={css({
            display: "flex",
            flexDirection: "column",
            gap: isOpen ? "var(--space-4)" : "0px",
            transition: "gap 0.2s ease-out",
          })}
        >
          <AccordionToggle
            className={css({
              borderRadius: "var(--border-radius-2)",
              display: "flex",
              alignItems: "center",
            })}
          >
            <div data-testid={testID}>
              <Icon
                name="arrow_right"
                size="space-5"
                className={css({
                  transform: isOpen ? "rotate(90deg) !important" : undefined,
                  transition: "transform 0.2s ease-out",
                  "@media print": { display: "none" },
                })}
              />
              <Text style="global/heading-large">{title}</Text>
            </div>
          </AccordionToggle>
          <AccordionPanel>{data}</AccordionPanel>
        </div>
      )}
    </Accordion>
  );
}
